import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Material } from '../../../portfolio/interfaces/material.interface';
import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { arrayToCsv } from 'src/utils/utils';

@Component({
  selector: 'app-promocion-regalos',
  templateUrl: './promocion-regalos.component.html',
  styleUrls: ['./promocion-regalos.component.css']
})
export class PromocionRegalosComponent implements OnInit {

  gridApi: any;
  gridColumnApi: any;
  columnDefsBonificadoresRegalo = [];
  frameworkComponents: any;
  rowDataBonificadoresRegalo: any[] = [];
  verFormularioAgregarBonificadorRegalo = false;

  regalo?: any;
  idPromo: string;
  tipoPromo: string;
  material: Material;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.gridComponent();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'] as string
      if (id) {
        this.idPromo = id;
        this.cargarBonificadorRegalo(id);
      }
    });
    this.route.queryParams.subscribe((query) => {
      this.tipoPromo = query['tipo_promo'];
    })
  }

  cargarBonificadorRegalo(id_promo: string) {
    this.promocionesService.cargarBonificadorRegalo(id_promo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.rowDataBonificadoresRegalo = resp;
        } else {
          this.rowDataBonificadoresRegalo = [];
        }
      },
      (error) => {
        this.rowDataBonificadoresRegalo = [];
      }
    );
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefsBonificadoresRegalo = [
      {
        headerName: 'Material',
        field: 'id_material',
        sortable: true,
        filter: true,
        width: '350px',
      },
      {
        headerName: 'Descripción Material',
        field: 'name_material',
        sortable: true,
        filter: true,
        width: '800px',
      },
      {
        headerName: 'Un',
        field: 'id_unidad',
        sortable: true,
        filter: false
      },
      {
        headerName: 'Ctd1',
        field: 'cantidad1',
        sortable: true,
        filter: false,
      },
      {
        headerName: 'Ctd2',
        field: 'cantidad2',
        sortable: true,
        filter: false,
      },
      {
        headerName: 'Ctd3',
        field: 'cantidad3',
        sortable: true,
        filter: false,
      },
      {
        headerName: 'Rel2.1',
        field: 'relacion21',
        sortable: true,
        filter: false,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.editarBonificadorRegalo.bind(this),
          label: 'Editar',
          colorBoton: 'btn btn-info btn-block',
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.eliminarBonificadorRegalo.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-danger btn-block',
        },
      },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  nuevoBonificadorRegalo() {
    this.regalo = undefined;
    this.verFormularioAgregarBonificadorRegalo = true;
  }

  editarBonificadorRegalo({ rowData }) {
    this.regalo = rowData;
    this.verFormularioAgregarBonificadorRegalo = true;
  }

  eliminarBonificadorRegalo({ rowData }) {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        // text: `ID PROMO: ${rowData.id_promo}`,
        action: 'Eliminar',
        funcion: this.promocionesService.borrarBonificadorRegalo(rowData),
      })
      .then((res: any) => {
        this.cargarBonificadorRegalo(this.idPromo);
      });
  }

  back() {
    this.verFormularioAgregarBonificadorRegalo = false;
    this.material = undefined;
  }

  materialSelected(material: Material) {
    this.material = material;
  }

  guardarBonificadorRegalo(payload: any) {
    payload.cantidad1 = payload.cantidad1 ? parseFloat(payload.cantidad1) : 0;
    payload.cantidad2 = payload.cantidad2 ? parseFloat(payload.cantidad2) : 0;
    payload.cantidad3 = payload.cantidad3 ? parseFloat(payload.cantidad3) : 0;
    payload.relacion21 = payload.relacion21 ? parseInt(payload.relacion21) : 0;

    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        // text: `ID PROMO: ${this.agregarForm.get('id_promo').value}`,
        action: this.regalo ? 'Editar' : 'Nuevo',
        funcion: this.promocionesService.crearBonificadorRegalo(payload),
      })
      .then((res: any) => {
        this.cargarBonificadorRegalo(this.idPromo);
        this.verFormularioAgregarBonificadorRegalo = false;
      });
  }

  eliminarTodo() {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        // text: `ID PROMO: ${rowData.id_promo}`,
        action: 'Eliminar',
        funcion: this.promocionesService.regaloDeleteAll(this.idPromo),
      })
      .then((res: any) => {
        this.cargarBonificadorRegalo(this.idPromo);
      });
  }

  downloadCsv() {
    let csv = arrayToCsv([
      ['idPromo','nombre promocion', 'idMaterial', 'descripcion material', 'unidad', 'cantidad1', 'cantidad2', 'cantidad3', 'relacion21'],
      ...this.rowsAsArray()
    ]);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);

    var pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', `regalos_${this.idPromo}.csv`);
    pom.click();
  }

  private rowsAsArray(): string[][] {
    const result:string[][] = [];
    this.rowDataBonificadoresRegalo.forEach((row) => {
      const csv = {
        id: row.id_promo,
        promo: row.name_promo,
        idMaterial: row.id_material,
        dscMaterial: row.name_material,
        unidad: row.id_unidad,
        cantidad1: row.cantidad1 ? row.cantidad1 : '',
        cantidad2: row.cantidad2 ? row.cantidad2 : '',
        cantidad3: row.cantidad3 ? row.cantidad3 : '',
        relacion21: row.relacion21 ? row.relacion21 : ''
      }
      result.push(Object.values(csv));
    })
    return result;
  }

}
